export const mockDataContacts = [
  {
    id: 1,
    name: "Lucas Dias",
    email: "lucasdias@gmail.com",
    age: 35,
    phone: "(69) 92387-3957",
    address: "Avenida Esbertalina Barbosa Damiani,352, Guriri Norte",
    city: "São Mateus",
    zipCode: "29946490",
    registrarId: 123512,
  },
  {
    id: 2,
    name: "João Dornas",
    email: "joaodornas@gmail.com",
    age: 42,
    phone: "(88) 92863-0559",
    address: "Rua das Fiandeiras, 67, Vila Olímpia",
    city: "Rio de Janeiro",
    zipCode: "34545005",
    registrarId: 123512,
  },
  {
    id: 3,
    name: "Cecília Nogueira",
    email: "cecilianogueira@gmail.com",
    age: 45,
    phone: "(94) 93004-4334",
    address: "Avenida Esbertalina Barbosa Damiani, 88, Guriri Norte",
    city: "São Mateus",
    zipCode: "29946490",
    registrarId: 4132513,
  },
  {
    id: 4,
    name: "Caio Lucas",
    email: "caiolucas@gmail.com",
    age: 16,
    phone: "(98) 92553-7013",
    address: "Avenida São João, 576, Vila Joana",
    city: "Jundiaí",
    zipCode: "13216000",
    registrarId: 123512,
  },
  {
    id: 5,
    name: "Erica Pereira",
    email: "ericapereira@gmail.com",
    age: 31,
    phone: "(69) 92226-3048",
    address: "Rua Pereira Estéfano, 23, Vila da Saúde",
    city: "São Paulo",
    zipCode: "04144070",
    registrarId: 4132513,
  },
  {
    id: 6,
    name: "Ludmilla Silva",
    email: "ludmillasilva@gmail.com",
    age: 15,
    phone: "(89) 93094-8286",
    address: "Praça da República, 93, República",
    city: "São Paulo",
    zipCode: "01045001",
    registrarId: 4132513,
  },
  {
    id: 7,
    name: "Enzo Morais",
    email: "enzomorais@gmail.com",
    age: 44,
    phone: "(82) 93983-6634",
    address: "Avenida Tocantins, 24, Vila Jardim Rio Claro",
    city: "Jataí",
    zipCode: "75802095",
    registrarId: 123512,
  },
  {
    id: 8,
    name: "Laura Cristina",
    email: "lauracristina@gmail.com",
    age: 36,
    phone: "(42) 92819-4641",
    address: "Travessa da CDL, 14, Centro",
    city: "Paraná",
    zipCode: "76900032",
    registrarId: 512315,
  },
  {
    id: 9,
    name: "Jessica Martins",
    email: "jessicamartins@gmail.com",
    age: 65,
    phone: "(64) 92351-9160",
    address: "Avenida São João, 11, Vila Joana",
    city: "Jundiaí",
    zipCode: "13216000",
    registrarId: 928397,
  },
  {
    id: 10,
    name: "Ricardo Pereira",
    email: "ricardopereira@gmail.com",
    age: 42,
    phone: "(64) 91354-9162",
    address: "Rua Paracatu, 99, Parque Imperial",
    city: "São Paulo",
    zipCode: "04302021",
    registrarId: 533215,
  },
  {
    id: 11,
    name: "Julia Ramos",
    email: "juliaramos02@gmail.com",
    age: 11,
    phone: "(64) 92357-9360",
    address: "Praça da República, 54, República",
    city: "São Paulo",
    zipCode: "01045201",
    registrarId: 92197,
  },
  {
    id: 12,
    name: "Jeniffer Luiza",
    email: "jenifferluiza@gmail.com",
    age: 17,
    phone: "(61) 97057-9482",
    address: "Praça dos Santos, 23, República",
    city: "Copacabana",
    zipCode: "01045243",
    registrarId: 92197,
  },
];

export const mockDataInvoices = [
  {
    id: 1,
    name: "Lucas Dias",
    email: "lucasdias@gmail.com",
    cost: "35.20",
    phone: "(69) 92387-3957",
    date: "12/08/2023",
  },
  {
    id: 2,
    name: "João Dornas",
    email: "joaodornas@gmail.com",
    cost: "13.02",
    phone: "(88) 92863-0559",
    date: "15/06/2023",
  },
  {
    id: 3,
    name: "Cecília Nogueira",
    email: "cecilianogueira@gmail.com",
    cost: "10.50",
    phone: "(94) 93004-4334",
    date: "02/05/2023",
  },
  {
    id: 4,
    name: "Caio Lucas",
    email: "caiolucas@gmail.com",
    cost: "90.27",
    phone: "(98) 92553-7013",
    date: "21/03/2023",
  },
  {
    id: 5,
    name: "Erica Pereira",
    email: "ericapereira@gmail.com",
    cost: "8.47",
    phone: "(69) 92226-3048",
    date: "01/12/2022",
  },
  {
    id: 6,
    name: "Ludmilla Silva",
    email: "ludmillasilva@gmail.com",
    cost: "47.62",
    phone: "(89) 93094-8286",
    date: "02/11/2022",
  },
  {
    id: 7,
    name: "Enzo Morais",
    email: "enzomorais@gmail.com",
    cost: "33.70",
    phone: "(82) 93983-6634",
    date: "11/02/2022",
  },
  {
    id: 8,
    name: "Laura Cristina",
    email: "lauracristina@gmail.com",
    cost: "54.10",
    phone: "(42) 92819-4641",
    date: "02/01/2022",
  },
  {
    id: 9,
    name: "Lucas Dias",
    email: "lucasdias@gmail.com",
    cost: "41.36",
    phone: "(69) 92387-3957",
    date: "04/09/2021",
  },
  {
    id: 10,
    name: "Enzo Morais",
    email: "enzomorais@gmail.com",
    cost: "33.70",
    phone: "(82) 93983-6634",
    date: "28/08/2021",
  },
  {
    id: 11,
    name: "Erica Pereira",
    email: "ericapereira@gmail.com",
    cost: "8.45",
    phone: "(69) 92226-3048",
    date: "17/08/2021",
  },
  {
    id: 12,
    name: "Laura Cristina",
    email: "laura cristina@gmail.com",
    cost: "34.10",
    phone: "(42) 92819-4641",
    date: "13/08/2021",
  },
  {
    id: 13,
    name: "João Dornas",
    email: "joaodornas@gmail.com",
    cost: "25.30",
    phone: "(88) 92863-0559",
    date: "19/07/2021",
  },
];

export const mockTransactions = [
  {
    txId: "LD-1218",
    user: "lucas dias",
    date: "12/08/2023",
    cost: "35,20",
  },
  {
    txId: "JD-1506",
    user: "joao dornas",
    date: "15/06/2023",
    cost: "13,02",
  },
  {
    txId: "CN-0205",
    user: "cecilia nog.",
    date: "02/05/2023",
    cost: "10,50",
  },
  {
    txId: "CL-2103",
    user: "caio lucas",
    date: "21/03/2023",
    cost: "90,27",
  },
  {
    txId: "EP-0112",
    user: "erica pereira",
    date: "01/12/2022",
    cost: "8,47",
  },
  {
    txId: "LS-0211",
    user: "ludmilla silva",
    date: "02/11/2022",
    cost: "47,62",
  },
  {
    txId: "EM-1102",
    user: "enzo morais",
    date: "11/02/2022",
    cost: "33,70",
  },
];

export const mockBarData = [
  {
    cidade: "MG",
    roupas: 115,
    roupasColor: "hsl(229, 70%, 50%)",
    sapatos: 20,
    sapatosColor: "hsl(296, 70%, 50%)",
    acessórios: 37,
    acessoriosColor: "hsl(97, 70%, 50%)",
    bolsas: 43,
    bolsasColor: "hsl(340, 70%, 50%)",
  },
  {
    cidade: "PE",
    roupas: 72,
    roupasColor: "hsl(307, 70%, 50%)",
    sapatos: 40,
    sapatosColor: "hsl(111, 70%, 50%)",
    acessórios: 39,
    acessoriosColor: "hsl(273, 70%, 50%)",
    bolsas: 12,
    bolsasColor: "hsl(275, 70%, 50%)",
  },
  {
    cidade: "SP",
    roupas: 125,
    roupasColor: "hsl(72, 70%, 50%)",
    sapatos: 45,
    sapatosColor: "hsl(96, 70%, 50%)",
    acessórios: 17,
    acessoriosColor: "hsl(106, 70%, 50%)",
    bolsas: 147,
    bolsasColor: "hsl(256, 70%, 50%)",
  },
  {
    cidade: "AG",
    roupas: 90,
    roupasColor: "hsl(257, 70%, 50%)",
    sapatos: 42,
    sapatosColor: "hsl(326, 70%, 50%)",
    acessórios: 13,
    acessoriosColor: "hsl(110, 70%, 50%)",
    bolsas: 89,
    bolsasColor: "hsl(9, 70%, 50%)",
  },
  {
    cidade: "BA",
    roupas: 104,
    roupasColor: "hsl(190, 70%, 50%)",
    sapatos: 86,
    sapatosColor: "hsl(325, 70%, 50%)",
    acessórios: 169,
    acessoriosColor: "hsl(54, 70%, 50%)",
    bolsas: 13,
    bolsasColor: "hsl(285, 70%, 50%)",
  },
  {
    cidade: "CE",
    roupas: 89,
    roupasColor: "hsl(208, 70%, 50%)",
    sapatos: 120,
    sapatosColor: "hsl(334, 70%, 50%)",
    acessórios: 105,
    acessoriosColor: "hsl(182, 70%, 50%)",
    bolsas: 7,
    bolsasColor: "hsl(76, 70%, 50%)",
  },
  {
    cidade: "RS",
    roupas: 70,
    roupasColor: "hsl(87, 70%, 50%)",
    sapatos: 34,
    sapatosColor: "hsl(141, 70%, 50%)",
    acessórios: 20,
    acessoriosColor: "hsl(224, 70%, 50%)",
    bolsas: 43,
    bolsasColor: "hsl(274, 70%, 50%)",
  },
];

export const mockPieData = [
  {
    id: "óculos",
    label: "óculos",
    value: 100,
    color: "hsl(104, 70%, 50%)",
  },
  {
    id: "calças",
    label: "calças",
    value: 297,
    color: "hsl(162, 70%, 50%)",
  },
  {
    id: "sapatos",
    label: "sapatos",
    value: 200,
    color: "green",
  },
  {
    id: "acessórios",
    label: "acessórios",
    value: 59,
    color: "hsl(229, 70%, 50%)",
  },
  {
    id: "bolsas",
    label: "bolsas",
    value: 73,
    color: "hsl(229, 70%, 50%)",
  },
  {
    id: "camisetas",
    label: "camisetas",
    value: 541,
    color: "hsl(229, 70%, 50%)",
  },
];

export const mockLineData = [
  {
    id: "SA",
    color: "#7fc97f",
    data: [
      {
        x: "óculos",
        y: 50,
      },
      {
        x: "calças",
        y: 100,
      },
      {
        x: "bolsas",
        y: 214,
      },
      {
        x: "acessórios",
        y: 180,
      },
      {
        x: "sapatos",
        y: 5,
      },
      {
        x: "camisetas",
        y: 45,
      },
    ],
  },
  {
    id: "PE",
    color: "#beaed4",
    data: [
      {
        x: "óculos",
        y: 200,
      },
      {
        x: "calças",
        y: 13,
      },
      {
        x: "bolsas",
        y: 50,
      },
      {
        x: "acessórios",
        y: 65,
      },
      {
        x: "sapatos",
        y: 160,
      },
      {
        x: "camisetas",
        y: 200,
      },
    ],
  },
  {
    id: "MG",
    color: "#fdc086",
    data: [
      {
        x: "óculos",
        y: -180,
      },
      {
        x: "calças",
        y: 300,
      },
      {
        x: "bolsas",
        y: -160,
      },
      {
        x: "acessórios",
        y: 20,
      },
      {
        x: "sapatos",
        y: 230,
      },
      {
        x: "camisetas",
        y: 260,
      },
    ],
  },
];
